module.exports = __webpack_public_path__ + "img/icon-step-6.b5cdfbb6.png";